module.exports = __webpack_public_path__ + "img/caosong.998ae68e.jpg";